/* eslint-disable */
/// <reference path="../types/index.d.ts" />
/* eslint-enable */

import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import Vuetify from 'vuetify'

import VTooltip from 'v-tooltip'

import { StorePlugin } from './store'
import Format from './utils/Format'
import Auth from './utils/Auth'
import Browser from './utils/Browser'
import Loadable from './components/Loadable'

import '../node_modules/vuetify/dist/vuetify.min.css'
import './assets/style.css'
import './assets/tooltip.css'
import './assets/custom.css'

Vue.config.productionTip = false
Vue.use(Vuetify)
Vue.use(StorePlugin)
Vue.use(Format)
Vue.use(Auth)
Vue.use(VTooltip)
Vue.use(Browser)

Vue.component('loadable', Loadable)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n: require('./locale').default,
  router: require('./router').default,
  template: '<App/>',
  components: { App: require('./App') }
})



// WEBPACK FOOTER //
// ./src/main.js